import { useEffect, useRef } from "react";

export const useSetElementOnStore = <T>(setElement: (e: T) => void) => {
  const ref = useRef<T>(null);

  useEffect(() => {
    if (!ref.current) return;
    setElement(ref.current);
  }, [setElement]);

  return ref;
};
